(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');
  var SCROLL_THRESHOLD = 50;

  function getThemesScript() {
    return document.querySelector('[id^="home-banner-header-themes-"]');
  }

  function parseThemes() {
    var script = getThemesScript();
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function syncHeaderLayoutHeights() {
    var root = document.documentElement;
    var navbarRow = document.querySelector('.header-v2--navbar > .ts-container');
    var legacyRow = document.querySelector('.header-v2--legacy .header-v2--container > .ts-container');

    if (DESKTOP_MQ.matches) {
      if (navbarRow) {
        root.style.setProperty('--header-navbar-h', navbarRow.offsetHeight + 'px');
      }
      return;
    }

    if (legacyRow) {
      root.style.setProperty('--header-legacy-h', legacyRow.offsetHeight + 'px');
    }
  }

  function HomeBannerHeaderSync() {
    this.headerNav = document.querySelector('header-navigation[data-is-index]');

    syncHeaderLayoutHeights();

    if (!this.headerNav) return;

    this.themeData = parseThemes();

    this.pcWrap = this.headerNav.querySelector('.header-v2--pc');
    this.navbar = this.headerNav.querySelector('.header-v2--navbar');
    this.legacyContainer = this.headerNav.querySelector('.header-v2--legacy .header-v2--container');
    this.legacyLogoImg = this.legacyContainer
      ? this.legacyContainer.querySelector('.header-logo-img')
      : null;

    this.defaultLegacyLogo =
      (this.legacyLogoImg && this.legacyLogoImg.getAttribute('src')) || '';
    this.defaultFontColor =
      this.headerNav.dataset.defaultFontColor ||
      getComputedStyle(this.headerNav).getPropertyValue('--default-header-font-color').trim() ||
      '#ffffff';

    this.currentIndex = 0;
    this.boundSwiper = null;

    this.onSwiperReady = this.onSwiperReady.bind(this);
    this.onSlideChange = this.onSlideChange.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    document.addEventListener('swiper-component:ready', this.onSwiperReady);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    DESKTOP_MQ.addEventListener('change', this.onResize);

    this.bindExistingSwiper();
    this.applyForCurrentState();
  }

  HomeBannerHeaderSync.prototype.bindExistingSwiper = function () {
    var swiperComponent = document.querySelector('swiper-component.section-home-banner-swiper');
    if (!swiperComponent || !swiperComponent.swiper) return;

    if (this.boundSwiper) {
      this.boundSwiper.off('slideChange', this.onSlideChange);
    }

    this.boundSwiper = swiperComponent.swiper;
    this.currentIndex = this.boundSwiper.realIndex;
    this.boundSwiper.on('slideChange', this.onSlideChange);
  };

  HomeBannerHeaderSync.prototype.resolveTheme = function (index) {
    var data = this.themeData;
    if (!data || !data.slides || !data.slides.length) {
      return {
        logo: this.defaultLegacyLogo,
        fontColor: this.defaultFontColor,
      };
    }

    var slide = data.slides[index] || {};
    var themeKey = slide.theme === 'dark' ? 'dark' : 'light';
    var logos = data.logos || {};
    var fontColors = data.fontColors || {};
    var logo =
      (themeKey === 'light' ? logos.light : logos.dark) || this.defaultLegacyLogo;
    var fontColor =
      slide.fontColor || fontColors[themeKey] || this.defaultFontColor;

    return {
      logo: logo,
      fontColor: fontColor,
    };
  };

  HomeBannerHeaderSync.prototype.applyPcState = function () {
    if (!this.navbar || !this.pcWrap) return;

    var stuck = window.scrollY > SCROLL_THRESHOLD;
    this.navbar.classList.toggle('is-stuck', stuck);

    if (stuck) {
      this.headerNav.style.setProperty('--default-header-font-color', this.defaultFontColor);
      return;
    }

    if (!this.themeData || !this.themeData.slides || !this.themeData.slides.length) {
      return;
    }

    var theme = this.resolveTheme(this.currentIndex);
    this.headerNav.style.setProperty('--default-header-font-color', theme.fontColor);
  };

  HomeBannerHeaderSync.prototype.applyLegacyState = function () {
    if (!this.legacyContainer) return;
    if (document.body.classList.contains('header-mobile-nav-open')) return;

    var floating = window.scrollY <= SCROLL_THRESHOLD;
    this.legacyContainer.classList.toggle('is--index', floating);

    if (!floating) {
      this.restoreLegacyDefaults();
      return;
    }

    if (!this.themeData || !this.themeData.slides || !this.themeData.slides.length) {
      return;
    }

    var theme = this.resolveTheme(this.currentIndex);
    if (this.legacyLogoImg && theme.logo) {
      this.legacyLogoImg.src = theme.logo;
    }
    this.headerNav.style.setProperty('--default-header-font-color', theme.fontColor);
  };

  HomeBannerHeaderSync.prototype.restoreLegacyDefaults = function () {
    if (this.legacyLogoImg && this.defaultLegacyLogo) {
      this.legacyLogoImg.src = this.defaultLegacyLogo;
    }
    this.headerNav.style.setProperty('--default-header-font-color', this.defaultFontColor);
  };

  HomeBannerHeaderSync.prototype.applyForCurrentState = function () {
    if (DESKTOP_MQ.matches) {
      this.applyPcState();
    } else {
      if (this.navbar) {
        this.navbar.classList.remove('is-stuck');
      }
      this.applyLegacyState();
    }
  };

  HomeBannerHeaderSync.prototype.onScroll = function () {
    this.applyForCurrentState();
  };

  HomeBannerHeaderSync.prototype.onResize = function () {
    syncHeaderLayoutHeights();
    this.applyForCurrentState();
  };

  HomeBannerHeaderSync.prototype.onSlideChange = function () {
    if (!this.boundSwiper) return;
    this.currentIndex = this.boundSwiper.realIndex;
    this.applyForCurrentState();
  };

  HomeBannerHeaderSync.prototype.onSwiperReady = function (event) {
    var swiperComponent = event.detail && event.detail.swiperComponent;
    if (!swiperComponent || !swiperComponent.classList.contains('section-home-banner-swiper')) {
      return;
    }

    if (this.boundSwiper) {
      this.boundSwiper.off('slideChange', this.onSlideChange);
    }

    this.boundSwiper = event.detail.swiper;
    this.currentIndex = this.boundSwiper.realIndex;
    this.boundSwiper.on('slideChange', this.onSlideChange);
    this.applyForCurrentState();
  };

  function init() {
    syncHeaderLayoutHeights();
    window.__homeBannerHeaderSync = new HomeBannerHeaderSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', syncHeaderLayoutHeights);
})();
